/**
 * Escapa um valor para ser interpolado com segurança em HTML (conteúdo de elemento ou valor de
 * atributo entre aspas). Obrigatório sempre que dados vindos do servidor forem montados via
 * template string + `.html()` — nomes de empresa/responsável, por exemplo, vêm do formulário
 * público do site e não passam por nenhuma sanitização.
 * @param {*} value     Valor a ser escapado (null/undefined viram string vazia)
 * @returns {string}
 */
function escapeHtml(value) {
    if (value === null || value === undefined) {
        return "";
    }

    return String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}
